import React from "react";
import Moment from "react-moment";
import { Box, Grid, Typography, Link } from "@mui/material";
import { stringFormate } from "src/common/utils/helpers";
import CommonShowNotes from "src/components/molecules/CommonShowNotes";

interface Props {
  field: string;
  value: any;
  isDateField?: boolean;
  asHtml?: boolean;
}

export const CardItem = ({ field, value, isDateField = false, asHtml }: Props) => {
  const [isNotesShowDrawerOpen, setIsNotesShowDrawerOpen] = React.useState(false);
  const [selectedData, setSelectedData] = React.useState<string>("");
  const changesTo = () => {
    if (asHtml) {
      return (
        <Typography style={{ whiteSpace: "nowrap", overflow: "hidden" }}>
          <Link
            component="button"
            variant="body1"
            onClick={() => {
              setSelectedData(value);
              setIsNotesShowDrawerOpen(true);
            }}
          >
            {stringFormate(value)}
          </Link>
        </Typography>
      );
    } else {
      return (
        <Typography>
          <Moment local={true} format="MM/DD/YYYY hh:mm A" date={value} />
        </Typography>
      );
    }
  };
  return (
    <>
      <Grid container item direction="row" xs={6} md={asHtml ? 10 : 4}>
        <Grid item xs={asHtml ? 2 : 5}>
          <Box color="text.secondary">
            <Typography>{`${field}: `}</Typography>
          </Box>
        </Grid>
        <Grid item xs={asHtml ? 10 : 7}>
          <Box color="text.primary">
            {(isDateField || asHtml) && Boolean(value) ? (
              changesTo()
            ) : (
              <Typography>{value}</Typography>
            )}
          </Box>
        </Grid>
      </Grid>
      <CommonShowNotes
        open={isNotesShowDrawerOpen}
        closed={() => setIsNotesShowDrawerOpen(false)}
        selectedData={selectedData}
        title="Notes"
      />
    </>
  );
};
